import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../../actions/application';
import { APPLICATION_CONTEXTS } from '../../../constants';
import ImageButton from '../imageButton';
import './styles.css';

class NavigationBar extends Component {
  handleOnKeyUp = event => {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    switch (event.key) {
      case 'B':
      case 'b':
        if (this.props.doGoBack) {
          // Special case for video playback
          this.props.history.go(-1);
          break;
        }
        if (this.props.backRoute) {
          this.props.history.push(this.props.backRoute);
        }
        break;
      default:
        break;
    }
  };

  componentWillMount() {
    document.addEventListener('keyup', this.handleOnKeyUp, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleOnKeyUp);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div id="navigation-bar">
        {this.props.mainMenu && (
          <ImageButton
            id="mainMenu"
            to="/"
            className="navigation-button navigation-button-main-menu"
            unhighlight={require('../images/btn_main.png')}
            alt="Main Menu"
            current={false}
          />
        )}
        {this.props.back && (
          <ImageButton
            id={this.props.backRoute}
            to={this.props.backRoute}
            className="navigation-button navigation-button-back"
            unhighlight={require('../images/btn_back.png')}
            alt="Back"
            current={false}
          />
        )}
      </div>
    );
  }
}

const ConnectedNavigationBar = connect(
  state => ({
    context: state.application.currentContext
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(NavigationBar);

export default withRouter(ConnectedNavigationBar);
